import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import { ErrorMessage, FormikValues, useFormikContext } from "formik";
import FormDropdownField from "../../../common/Form/Dropdown/FormDropdownField";
import InputField from "../../../common/Form/Input/InputField";
import {
  ALL_STUDY_PHASE,
  SUBMISSION_TYPES,
  TYPES_OF_FUNDING,
  ALL_TYPE_OF_STUDY,
  EC_SUBMISSION_TYPES,
} from "../../../../constants";
import {
  useGetIrbSubmissionInfoLazyQuery,
  useGetProtocolListQuery,
} from "../../../../generated/graphql";
import FormToggleButton from "../../../common/Form/ToggleButton/FormToggleButton";
import DropdownWithOther from "../../IRB/IRBSubmission/CreateIRBSubmission/StudyDetails/DropdownWithOther";
import {
  DEPARTMENT,
  FUND_TYPE,
  IS_FUNDED,
  MICR,
  PRINCIPAL_INVESTIGATOR,
  PROTOCOL_NUMBER,
  SPONSOR,
  STUDY_PHASE,
  TITLE,
  TYPE_OF_STUDY,
} from "../../../../constants/forms";

type studyDetailsProps = {
  value?: number;
  type?: string;
};

const StudyDetailsSae = (props: studyDetailsProps): JSX.Element => {
  const { value, type } = props;
  let subType = "";
  switch (type) {
    case "SAE":
      subType = "SAE";
      break;
    case EC_SUBMISSION_TYPES.STUDY_CLOSEOUT_REPORT:
      subType = EC_SUBMISSION_TYPES.STUDY_CLOSEOUT_REPORT;
      break;
    default:
      subType = "";
      break;
  }
  const { data, loading, error } = useGetProtocolListQuery({
    variables: {
      subType: subType,
      submissionType: SUBMISSION_TYPES.EC,
    },
  });

  const protocolNumbers = data?.getProtocolList.map((item, i) => {
    return item.protocolNumber;
  });

  let id: string;
  const getIdFromValue = (number: string) => {
    data?.getProtocolList.forEach((item, i) => {
      if (item.protocolNumber === number) {
        id = item._id;
      }
    });
    return id;
  };
  const { values, setFieldValue, setValues } = useFormikContext<FormikValues>();
  const [getIrbById] = useGetIrbSubmissionInfoLazyQuery();
  const dropdownInputHandler = (fieldName: string, value: any) => {
    setFieldValue(fieldName, value);
  };
  const dropdownInputHandlerPN = async (fieldName: string, value: any) => {
    const id = getIdFromValue(value);
    // api call
    const newValues = await getDataFromProtocolNumber(id);
    setValues({
      ...newValues,
      [fieldName]: value,
    });
    // setFieldValue(fieldName, value);
  };
  const checkboxInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.checked);
  };

  const getDataFromProtocolNumber = async (id: string) => {
    const { data } = await getIrbById({
      variables: { id },
    });
    if (data) {
      const {
        department,
        emails,
        isFunded,
        fundType,
        principalInvestigator,
        sponsor,
        studyPhase,
        title,
        micr,
        typeOfStudy,
      } = data.irb;
      return {
        ...values,
        department,
        emails,
        isFunded,
        fundType,
        principalInvestigator,
        sponsor,
        studyPhase,
        title,
        micr,
        typeOfStudy,
        isTermsAccepted: true,
      };
    }
    return values;
  };

  const toggleHandler = (e: React.MouseEvent, newToggle: boolean) => {
    setFieldValue("isFunded", newToggle);
    if (newToggle) {
      setFieldValue("fundType", "");
    }
  };

  return (
    <>
      <FormDropdownField
        label=" 1.1 Protocol Number/Short Title"
        value={values[PROTOCOL_NUMBER]}
        name={PROTOCOL_NUMBER}
        options={protocolNumbers} //make this dynamic
        inputHandler={dropdownInputHandlerPN}
        // disabled={!!id}
      />

      {/* <InputField
        label={"1.2 MICR #"}
        name={MICR}
        placeholder={"Short Text"}
        value={values.micr}
        // disabled={!!id}
      /> */}
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">1.2 MICR #</label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[MICR]}
        </Typography>
      </Box>
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">
          1.3 Study Title
        </label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[TITLE]}
        </Typography>
      </Box>
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">1.4 Sponsor</label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[SPONSOR]}
        </Typography>
      </Box>
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">
          1.5 Principal Investigator
        </label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[PRINCIPAL_INVESTIGATOR]}
        </Typography>
      </Box>
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">
          1.6 Department
        </label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[DEPARTMENT]}
        </Typography>
      </Box>

      <DropdownWithOther
        label="1.7 Study Phase"
        name={STUDY_PHASE}
        placeholder={"Study Phase"}
        options={ALL_STUDY_PHASE}
        disabled={false}
      />

      <DropdownWithOther
        label="1.8 Type of Study"
        name={TYPE_OF_STUDY}
        placeholder={"Type of Study"}
        options={ALL_TYPE_OF_STUDY}
        disabled={false}
      />

      <Box className="mg-b-10">
        <label className="form-label mg-b-20 font-size-14 font-weight-medium">
          1.9 Funding/Grant
        </label>
        <FormToggleButton name={IS_FUNDED} onChange={toggleHandler} />
      </Box>

      {values["isFunded"] && (
        <DropdownWithOther
          label="Type of Funding"
          name={FUND_TYPE}
          placeholder={"Type of Funding"}
          options={TYPES_OF_FUNDING}
          disabled={false}
        />
      )}

      {/* <Box className={"custom-checkbox mg-b-50"}>
        <Checkbox
          checked={values.isTermsAccepted}
          name="isTermsAccepted"
          onChange={checkboxInputHandler}
          //   disabled={!!id}
        />
        <label className="form-label font-size-14 font-weight-medium">
          Terms and Conditions
        </label>
        <ErrorMessage
          name="isTermsAccepted"
          render={(msg) => {
            return (
              <div>
                <span className="text-danger font-size-sm">{msg}</span>
              </div>
            );
          }}
        />
      </Box> */}
    </>
  );
};

export default StudyDetailsSae;
